import React, { useMemo } from 'react';
import { IProductReview } from '../../../entities-generated/common/product-review';
import { IProductTexture } from '../../../entities-generated/common/product-texture';
import { IBrowserImage } from '../../../framework/components/bwj-image-browser';
import { BwjViewManager, BwjViewState } from '../../../framework/components/bwj-view-manager';
import { ProductDetailDialogContentDesktop } from './desktop';
import { ProductDetailDialogContentMobile } from './mobile';
import { ICustomerEnrollmentFormModel } from '../../form-services/customer-enrollment-iface';

export interface IProductDetailDialogDisplayProps {
  id: string;
  brand: string;
  title: string;
  averageRating?: number | undefined;
  rating?: IProductReview | undefined;
  keyFeatures: string[];
  variants: IProductTexture[];
  variantDescriptor: string;
  measurementRequestDate: Date | null;
  requestMeasurementFormModel: ICustomerEnrollmentFormModel;
  onMeasurementRequestSubmitted: () => void;
  onShowPricingExplanation: () => void;
}

export interface IProductDetailDialogContentProps extends IProductDetailDialogDisplayProps {
  imageUrls: IBrowserImage[];
  displayedImageIndex: number;
  showMeasurementRequestForm: boolean;
  onToggleMeasurementRequestForm: (show: boolean) => void;
  onDisplayedIndexChanged: (index: number) => void;
  selectedVariant: IProductTexture | null;
  onVariantSelected: (variant: IProductTexture) => void;
  contentWidth: number;
}

export const ProductDetailDialogContent: React.FunctionComponent<IProductDetailDialogContentProps> = (props) => {
  const { contentWidth } = props;
  const viewState = useMemo(() => {
    return contentWidth === 0 ? BwjViewState.Loading : BwjViewState.Ready;
  }, [contentWidth]);

  return (
    <BwjViewManager
      state={viewState}
      loadingState={{
        message: '',
      }}
    >
      {props.contentWidth < 620 ?
      <ProductDetailDialogContentMobile {...props} />
      :
      <ProductDetailDialogContentDesktop {...props} />}
    </BwjViewManager>
  );
};
